export const translations = {
  // Общие элементы
  common: {
    close: 'Закрыть',
    submit: 'Отправить',
    cancel: 'Отмена',
    save: 'Сохранить',
    edit: 'Редактировать',
    delete: 'Удалить',
    loading: 'Загрузка...',
    error: 'Ошибка',
    success: 'Успешно',
    yes: 'Да',
    no: 'Нет',
    maybe: 'Возможно',
  },

  // Авторизация
  auth: {
    title: '30-летие Влада',
    subtitle: 'Введите секретный ключ приглашения',
    nameLabel: 'Имя:',
    namePlaceholder: 'Введите ваше имя',
    secretKeyLabel: 'Секретный ключ:',
    secretKeyPlaceholder: 'Введите секретный ключ',
    loginButton: 'Войти',
    checking: 'Проверка...',
    invalidKey: 'Неверный секретный ключ. Проверьте приглашение.',
    keyUsed: 'Этот ключ уже использован. Обратитесь к Владу за новым ключом.',
    loginFailed: 'Ошибка входа. Попробуйте еще раз.',
    footer: '🎮 Win95 Style • 🎵 Ностальгия • 🎉 Режим вечеринки',
  },

  // Boot экран
  boot: {
    initializing: 'Инициализация системы...',
    loadingComponents: 'Загрузка компонентов Win95...',
    checkingConfig: 'Проверка конфигурации вечеринки...',
    welcome: 'Добро пожаловать, {name}!',
    preparing: 'Подготовка среды для дня рождения...',
    ready: 'Система готова!',
  },

  // Рабочий стол
  desktop: {
    start: 'Пуск',
    logout: 'Выйти',
    userInfo: '👤 {name} • {time}',
  },

  // Окна
  windows: {
    invitation: {
      title: 'Расписание.exe',
      mainTitle: 'МНЕ 30 🥲',
      subtitle: 'Ты приглашён отпраздновать со мной этот прекрасный день 🎉',
      day1Title: 'День 1 - Пятница, 18 июля (День рождения)',
      day1Time: 'Начало: 16:00',
      day1Program: [
        '🍺 Попить пивка',
        '🧖‍♂️ Банька',
        '💬 Пообщаться',
        '🍕 Пицца',
        '😌 Чилл формат'
      ],
      day2Title: 'День 2 - Суббота, 19 июля (Основная вечеринка)',
      day2Time: 'Начало: 12:00',
      day2Program: [
        '🍽️ Кухня',
        '🎵 Караоке',
        '🎯 Конкурсы',
        '💨 Кальяны',
        '🧖‍♂️ Банька',
        '🎊 Веселье до утра!'
      ],
      location: 'Место:',
      locationValue: 'г. Могилев, Пехотный переулок, 19',
      dressCode: 'Дресс-код:',
      dressCodeValue: 'Белые майки (особенно которые не жалко испортить) + атрибуты 90-х приветствуются!',
      otherWindows: 'Другие окна на рабочем столе:',
      windowsInfo: [
        '✅ Подтверждение участия — САМОЕ ВАЖНОЕ! Подтверди участие',
        '🎁 Подарки — виш-лист, если не знаешь что подарить',
        '📖 Гостевая книга — пожелания, шутки, ожидания от вечеринки',
      ],
      rsvpNote: 'Обязательно подтверди участие!',
      confirmButton: 'Подтвердить участие',
    },

    about: {
      title: 'О Владе.exe',
      mainTitle: 'О Владе',
      whoAmI: '👨‍💻 Кто я:',
      whoAmIText: 'Влад, 30 лет, разработчик, любитель ретро-технологий и хороших вечеринок.',
      favorites: '🎮 Любимые вещи:',
      favoritesList: [
        'Windows 95 и ретро-компьютеры',
        'Музыка 90-х и 2000-х',
        'Программирование',
        'Путешествия',
        'Хорошая компания'
      ],
      whySpecial: '🎉 Почему эта вечеринка особенная:',
      whySpecialText: 'Хочу отпраздновать 30-летие в стиле, который мне близок - с ностальгией по 90-м, хорошей музыкой и отличными людьми!',
      footer: 'Спасибо, что ты здесь! 🎂',
    },

    photos: {
      title: 'Фото.exe',
      mainTitle: 'Фотогалерея',
      childhood: 'Детство',
      university: 'Студенчество',
      current: 'Сейчас',
      photoPlaceholders: {
        childhood: ['👶 Фото 1', '🎮 Фото 2', '🏫 Фото 3', '🎂 Фото 4'],
        university: ['📚 Фото 1', '🎓 Фото 2', '🍺 Фото 3', '💻 Фото 4'],
        current: ['💼 Фото 1', '✈️ Фото 2', '🎵 Фото 3', '🎉 Фото 4'],
      },
      footer: 'Больше фотографий будет добавлено позже!',
    },

    rsvp: {
      title: 'Подтверждение присутствия.exe',
      nameLabel: 'Имя:',
      namePlaceholder: 'Введите своё имя',
      attendanceLabel: 'Сможете присутствовать?',
      attendanceYes: 'Да, буду',
      attendanceNo: 'К сожалению, нет',
      attendanceMaybe: 'Возможно, напишу влс',
      daysLabel: 'Какие дни планируете посетить?',
      day1Label: 'День 1 (Пятница) - Чил, банька, пицца',
      day2Label: 'День 2 (Суббота) - Главная вечеринка',
      overnightLabel: 'Ночёвка',
      overnightOneDay: 'Один день',
      overnightTwoDays: 'Два дня',
      overnightNo: 'Нет',
      plusOneLabel: 'Будет ли с вами плюс один?',
      hasChildLabel: 'Будет ли ребенок?',
      alcoholPreferencesLabel: 'Предпочтения по алкоголю:',
      alcoholPreferencesPlaceholder: 'Укажите ваши предпочтения',
      messageLabel: 'Сообщение (опционально):',
      messagePlaceholder: 'Можешь оставить комментарий или пожелание',
      submitButton: 'Отправить',
      submitting: 'Отправка...',
      successTitle: 'Спасибо за подтверждение!',
      successMessage: 'Твой ответ был успешно сохранен.',
      successFooter: 'Ждем тебя на празднике!',
      errorMessage: 'Ошибка при отправке формы. Попробуйте позже.',
    },

    wishlist: {
      title: 'Подарки.exe',
      mainTitle: 'Список желаний',
      description: 'Если не знаешь что подарить, то вот список:',
      addGift: 'Добавить подарок',
      reserveGift: 'Забронировать',
      cancelReservation: 'Отменить бронь',
      giftName: 'Название подарка',
      giftLink: 'Ссылка на подарок',
      reservedBy: 'Забронировано',
      available: 'Доступно',
      noGifts: 'Подарки пока не добавлены',
    },

    guestbook: {
      title: 'Гостевая книга.exe',
      mainTitle: 'Гостевая книга',
      writeMessage: 'Написать сообщение',
      messagePlaceholder: 'Оставьте пожелание или сообщение...',
      authorPlaceholder: 'Ваше имя',
      submitMessage: 'Отправить',
      messages: 'Сообщения',
      noMessages: 'Сообщений пока нет',
    },

    music: {
      title: 'Музыка.exe',
      mainTitle: 'Музыкальный плеер',
      nowPlaying: 'Сейчас играет:',
      playlist: 'Плейлист',
      volume: 'Громкость',
      play: '▶️',
      pause: '⏸️',
      next: '⏭️',
      prev: '⏮️',
      noTracks: 'Треки не загружены',
    },

    timer: {
      title: 'Таймер.exe',
      mainTitle: 'До вечеринки осталось:',
      days: 'дней',
      hours: 'часов',
      minutes: 'минут',
      seconds: 'секунд',
      partyStarted: '🎉 Вечеринка началась!',
    },

    game: {
      title: 'Игра.exe',
      mainTitle: 'Найди подарок',
      instructions: 'Найди спрятанный подарок на рабочем столе!',
      found: '🎁 Подарок найден!',
      notFound: 'Попробуй еще раз...',
      restart: 'Начать заново',
    },

    secret: {
      title: 'Secret.exe',
      mainTitle: 'Секретный режим',
      chatPlaceholder: 'Введите сообщение...',
      sendMessage: 'Отправить',
      messages: 'Сообщения',
      neonMode: 'Неоновый режим',
      partyMode: 'Режим вечеринки',
    },

    welcome: {
      title: 'Добро пожаловать!',
      mainTitle: '🎉 Добро пожаловать на 30-летие Влада!',
      greeting: 'Привет! Это интерактивное приглашение на день рождения. Отмечаем 30-летие с хорошей музыкой и отличной компанией. Будет весело!',
      important: '❗ Важно:',
      importantText: 'Обязательно подтверди участие - это поможет нам лучше организовать праздник!',
      whatToDo: 'Что нужно сделать:',
      todoList: [
        '✅ Подтвердить участие (самое важное!)',
        '🎁 Посмотреть список подарков',
        '📖 Оставить пожелание в гостевой книге',
        '📋 Прочитать детали в расписании'
      ],
      tips: 'Совет: если хочешь принести что-то из атрибутики прошлых лет - будет круто!',
      navigation: 'Навигация:',
      navigationTip: 'Кликай на иконки рабочего стола. Начни с "Приглашение" и "Подтверждение участия"!',
      closeButton: 'Понятно, поехали!',
      dontShowAgain: 'Не показывать снова',
    },
  },

  // Программа вечеринки
  party: {
    day1: {
      title: 'День 1 (Пятница)',
      events: [
        'Чил и общение',
        'Банька',
        'Пицца/шашлык',
        'Ночёвка для своих'
      ]
    },
    day2: {
      title: 'День 2 (Суббота)',
      events: [
        'Главная вечеринка',
        'Кухня',
        'Конкурсы',
        'Баня',
        'Фотки'
      ]
    }
  },

  // Тестовые ключи
  testKeys: {
    vlad30: 'Vlad',
    friend1: 'Alex',
    friend2: 'Maria',
    friend3: 'Dmitry',
    friend4: 'Anna',
    family1: 'Mom',
    family2: 'Dad',
    colleague1: 'Sergey',
    colleague2: 'Elena',
  }
};

// Функция для получения перевода с подстановкой переменных
export const t = (key: string, params?: Record<string, string | number>): string => {
  const keys = key.split('.');
  let value: any = translations;
  
  for (const k of keys) {
    value = value?.[k];
    if (value === undefined) {
      console.warn(`Translation key not found: ${key}`);
      return key;
    }
  }

  if (typeof value === 'string' && params) {
    return value.replace(/\{(\w+)\}/g, (match, param) => {
      return params[param]?.toString() || match;
    });
  }

  return value;
};

// Типы для TypeScript
export type TranslationKey = keyof typeof translations; 